import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaBoxOpen, FaKey, FaLock, FaSignOutAlt } from "react-icons/fa";
import useAuth from "../hooks/useAuth.js";
import { API_BASE } from "../config/api"; // adjust path if needed
import axios from "axios";
import "./AccountPage.css";
import useCart from "../hooks/useCart";
import useWishlist from "../hooks/useWishlist";

const AccountPage = () => {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loadingOrders, setLoadingOrders] = useState(false);
  const { clearCart } = useCart();
  const { clearWishlist } = useWishlist();

  useEffect(() => {
    if (!loading && !user) {
      navigate("/login");
    } else if (user) {
      // Fetch user orders
      fetchOrders();
    }
  }, [user, loading, navigate]);

  const fetchOrders = async () => {
    try {
      setLoadingOrders(true);
      const response = await axios.get(API_BASE, {
        withCredentials: true,
      });
      setOrders(response.data);
      setLoadingOrders(false);
    } catch (error) {
      console.error("Error fetching orders:", error);
      setLoadingOrders(false);
    }
  };

  const handleLogout = async () => {
    await logout();
    clearCart();
    clearWishlist();
    navigate("/login");
  };

  const handleResetPassword = () => {
    navigate("/reset-password");
  };

  const handleForgotPassword = () => {
    navigate("/forgot-password");
  };

  const handleOrderTracking = () => {
    navigate('/order');
  };

  const userInitial = user?.name?.charAt(0)?.toUpperCase() || "?";

  if (loading || !user) return <div className="account-loading">Loading...</div>;

  return (
    <div className="account-page">
      <div className="account-container">
        <div className="account-header">
          <div className="account-avatar">{userInitial}</div>
          <h2>My Account</h2>
        </div>

        <div className="account-details">
          <div className="account-details-inner">
            <div className="account-detail-row">
              <strong>Name</strong>
              <span>{user.name}</span>
            </div>
            <div className="account-detail-row">
              <strong>Email</strong>
              <span>{user.email}</span>
            </div>
            <div className="account-detail-row">
              <strong>Phone</strong>
              <span>{user.phone}</span>
            </div>
            <div className="account-detail-row">
              <strong>Verified</strong>
              <span className="account-verified">
                {user.accountVerified ? "✅ Yes" : "❌ No"}
              </span>
            </div>
          </div>
        </div>

        <div className="account-actions">
          <button onClick={handleOrderTracking} className="account-btn-primary">
            <FaBoxOpen /> Order Tracking
          </button>
          <button onClick={handleResetPassword} className="account-btn-primary">
            <FaKey /> Reset Password
          </button>
          <button onClick={handleForgotPassword} className="account-btn-primary">
            <FaLock /> Forgot Password
          </button>
          <button onClick={handleLogout} className="logout-btn">
            <FaSignOutAlt /> Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountPage;
